import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Records from '../Records'
import * as UI from '../../Shared.styles'

export const NonCompatibleBrandResultListWrapper = ({ records, vehicleName }) =>
  <Wrapper>
    <UI.BrandsDrawer accordion shade title={ `Currently Incompatible with your ${vehicleName}` }>
      <Center>
        <Records records={ records } />
      </Center>
    </UI.BrandsDrawer>
  </Wrapper>

NonCompatibleBrandResultListWrapper.propTypes = {
  records: PropTypes.arrayOf(PropTypes.object),
  vehicleName: PropTypes.string
}

const Wrapper = styled(UI.Wrapper)`
  text-align: left;
`

const Center = styled.div`
  text-align: center;
`
